import {logger} from "../utils/Logger";

/**
 * Represents the session storage key used to save the location
 */
const SAVED_LOCATION_SESSION_STORAGE_KEY = "savedLocation"

function getSavedLocation() : string | null {
    return sessionStorage.getItem(SAVED_LOCATION_SESSION_STORAGE_KEY);
}

function setSavedLocation(location : string)
{
    logger.debug("Save location " + location)

    sessionStorage.setItem(SAVED_LOCATION_SESSION_STORAGE_KEY, location);
}

function clearSavedLocation(){
    sessionStorage.removeItem(SAVED_LOCATION_SESSION_STORAGE_KEY);
}

export const SavedLocation = () => {
    return
}

SavedLocation.getSavedLocation = getSavedLocation;
SavedLocation.setSavedLocation = setSavedLocation;
SavedLocation.clearSavedLocation = clearSavedLocation;